/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
const { shape, func } = proptypes;
import { LaundryBundleImage } from './laundry/LaundryBundleImage';
import { getGridClasses } from '../utils/ui';
import { getBundleImage } from '../utils/product-utils';
import ProductPodLayout from './laundry/ProductPodLayout';
import LaundryContainerTitle from './LaundryContainerTitle';
import { LAUNDRY_ACCESSORIES_DRAWER, LAUNDRY_GRID_BASE } from '../constants/index';
import { LaundryProductDetails } from './laundry/LaundryProductDetails';

const AccessoriesContainer = ({
  accessories = {},
  onSwap
}) => {
  const productPreview = {
    ...(accessories?.products?.[0] || {}),
    selectableVariants: accessories?.variants || [],
    selectedVariant: accessories?.selectedVariant || ''
  };

  const { identifiers } = productPreview || {};
  const { productLabel } = identifiers || {};
  const itemId = productPreview?.itemId || '';

  const handleChange = (value) => {
    onSwap({
      offeringName: value
    });
  };

  const gridClasses = getGridClasses({
    md: 4,
    lg: 2
  });
  return (
    <>
      <div
        data-testid="accessories-container"
        className={`sui-px-3 md:sui-px-0 md:sui-grid ${LAUNDRY_GRID_BASE} ${gridClasses}`}
      >
        <div className="sui-hidden md:sui-block sui-py-1 md:sui-col-span-4 lg:sui-col-span-2">
          <LaundryContainerTitle text="Storage & Stacking Accessories" variantNames={[LAUNDRY_ACCESSORIES_DRAWER]} />
        </div>
        <div className="sui-py-4 md:sui-col-span-3 lg:sui-col-span-2">
          <ProductPodLayout
            leftColumn={(
              <LaundryBundleImage itemId={itemId} src={getBundleImage(productPreview, 2)} alt={productLabel} />
            )}
            rightColumn={(
              <div className="sui-flex sui-flex-col sui-items-start sui-gap-3">
                <div className="md:sui-hidden">
                  <LaundryContainerTitle
                    text="Storage & Stacking Accessories"
                    wrap
                    variantNames={[LAUNDRY_ACCESSORIES_DRAWER]}
                  />
                </div>
                <LaundryProductDetails product={productPreview} onSwapVariant={handleChange} />
              </div>
            )}
          />
        </div>
      </div>
    </>
  );
};

AccessoriesContainer.propTypes = {
  accessories: shape({}),
  onSwap: func.isRequired
};

AccessoriesContainer.dataModel = LaundryProductDetails.dataModel;

export default AccessoriesContainer;